import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(string: string, n?: number): string {
    if (typeof string !== "string") return string;
    if (n === undefined) return string; // Return the original string if n is undefined
    return string.length > n ? string.substring(0, n) + "..." : string;
  }
}

